import React, { useEffect, useState } from 'react';
import { FC } from 'react';
import {
    Bold,
    Container,
    Description,
    Label,
    Link,
    SectionNumber,
    Title,
    Wrapper,
} from './BusinessConditions.elements';

export interface BusinessConditionsProps {}

const BusinessConditionsTemplate: FC<BusinessConditionsProps> = () => {
    return (
        <Wrapper>
            <Title>VŠEOBECNÉ OBCHODNÍ PODMÍNKY</Title>
            <br />
            <Label>VYDAVATELSKÉHO A VZDĚLÁVACÍHO DOMU PORADCE PODNIKATELE</Label>
            <br />
            <Label>Školení a konference</Label>
            <Container>
                <Label>1. ÚVODNÍ USTANOVENÍ</Label>
                <Description>
                    <SectionNumber>1.1.</SectionNumber>
                    <div>
                        <span>
                            Tyto všeobecné obchodní podmínky (dále jen <strong>&apos;VOP&apos;</strong>) upravují práva
                            a povinnosti vzdělávacího domu Poradce podnikatele (dále jen{' '}
                            <strong>&apos;Poskytovatel&apos;</strong>), který tvoří následující společnosti:
                        </span>
                        <br />
                        <br />
                        <span>
                            · <strong>Poradce podnikatele, spol. s r.o.</strong>, se sídlem: Praha 7, Jablonského 639/4,
                            PSČ 17000, IČO: 49678876, společnost zapsaná v obchodním rejstříku vedeném Městským soudem
                             v Praze oddíl C vložka 21589,
                        </span>
                        <br />
                        <br />
                        <span>
                            · <strong>NOTIA Středisko vzdělávání, spol. s r.o.</strong>, se sídlem: Praha 7, Jablonského
                            639/4, PSČ 17000, IČO: 64944077, společnost zapsaná v obchodním rejstříku vedeném Městským
                            soudem  v Praze oddíl C vložka 42599,
                        </span>
                        <br />
                        <br />
                    </div>
                </Description>
                <Description>
                    <SectionNumber>1.2.</SectionNumber>
                    <span>
                        Poskytovatel je provozovatelem internetových portálů https://pp.cz/,
                        https://www.zakonyprolidi.cz/ https://www.notiavzdelavani.cz/, a https://www.daneprolidi.cz/ a
                        https://www.studiow.cz/, https://www.ppvs.cz/ (dále jen „Webové portály“), jako služeb
                        informační společnosti ve smyslu zákona č. 480/2004 Sb., o některých službách informační
                        společnosti a o změně některých zákonů (zákon o některých službách informační společnosti), ve
                        znění pozdějších předpisů.
                    </span>
                </Description>
                <Description>
                    <SectionNumber>1.3.</SectionNumber>
                    <span>
                        Poskytovatel poskytuje pro Uživatele seminář/webináře a/nebo konference/kongresy. Seminářem nebo
                        webinářem se pro účely těchto VOP rozumí odborné studium, jehož podstatou je zajištění přednášky
                        či série přednášek s diskusí a připomínkami posluchačů, které je soustředěno na danou oblast
                        vzdělávání. Konferencí/kongresem se rozumí odborná akce zaměřená na zajištění přednášky či série
                        přednášek s diskusí a připomínkami posluchačů,  s ohledem na danou oblast vzdělávání (dále jen
                        souhrnně jako <strong>„Vzdělávací akce“</strong>). Poskytovatel poskytuje Vzdělávací akce
                        prezenční i online formou.
                    </span>
                </Description>
                <Description>
                    <SectionNumber>1.4.</SectionNumber>
                    <span>
                        Vzdělávací akce jsou zaměřeny na kompletní daňovou a účetní problematiku, finanční a mzdové
                        účetnictví, obchodní právo, obchodní dovednosti, marketing, manažerské vzdělávání, osobní rozvoj
                        a na další oblasti vzdělávání atd. Nabídka Vzdělávacích akcí je přístupná na webových stránkách
                        https://www.studiow.cz .
                    </span>
                </Description>
                <Description>
                    <SectionNumber>1.5.</SectionNumber>
                    <span>
                        Uživatelem se pro účely těchto VOP rozumí fyzické nebo právnické osoby, které využívají nebo
                        nakupují Vzdělávací akce poskytované Poskytovatelem na základě smluvního vztahu a těchto VOP
                        (dále jen Uživatel). K využívání Vzdělávací akce je nutná registrace Uživatele, s výjimkou
                        těch Vzdělávacích akcí, jejichž technická povaha takovou registraci nevyžaduje. Uživatel  a
                        Poskytovatel dále také společně jako <strong>Smluvní strany</strong> a jednotlivě jako{' '}
                        <strong>Smluvní strana</strong>.
                    </span>
                </Description>
            </Container>
            <Container>
                <Label>2. PŘEDMĚT SMLOUVY</Label>
                <Description>
                    <SectionNumber>2.1.</SectionNumber>
                    <span>
                        VOP upravují práva a povinnosti Uživatelů a stanovují podmínky, za kterých Poskytovatel
                        poskytuje Uživatelům Vzdělávací akce, jejichž seznam je uveden v Příloze č. 1 těchto VOP.
                    </span>
                </Description>
            </Container>
            <Container>
                <Label>3. UZAVŘENÍ SMLOUVY</Label>
                <Description>
                    <SectionNumber>3.1.</SectionNumber>
                    <span>
                        Smluvní vztah mezi Poskytovatelem a Uživatelem (dále jen <strong>„Smlouva“</strong>) vzniká (i)
                        zaplacením ceny Vzdělávací akce ze strany Uživatele uvedené na zálohové faktuře vystavené
                        Poskytovatelem, (ii) vyplněním a potvrzením objednávky ze strany Uživatele přímo na Webových
                        portálech Poskytovatele (dále jen <strong>„Objednávka“</strong>) nebo (iii) uzavřením písemné
                        smlouvy o poskytnutí Vzdělávací akce.
                    </span>
                </Description>
                <Description>
                    <SectionNumber>3.2.</SectionNumber>
                    <div>
                        <span>Objednávka může být Objednatelem Poskytovateli doručena:</span>
                        <br />
                        <br />
                        <span>· Prostřednictvím Webových portálů,</span>
                        <br />
                        <br />
                        <span>· Doporučeným dopisem na adresu Poskytovatele,</span>
                        <br />
                        <br />
                        <span>· Osobně na adrese Poskytovatele nebo v jiném místě určeném Poskytovatelem,</span>
                        <br />
                        <br />
                        <span>· E-mailem Poskytovateli,</span>
                        <br />
                        <br />
                        <span>· Prostřednictvím sociálních sítí Poskytovatele,</span>
                        <br />
                        <br />
                        <span>· Datovou schránkou Poskytovatele</span>
                        <br />
                        <br />
                        <span>
                            · Jakýmkoliv jiným způsobem, ze kterého bude oběma Smluvním stranám bez důvodných
                            pochybností zřejmé, že jde o Objednávku.
                        </span>
                        <br />
                        <br />
                    </div>
                </Description>
                <Description>
                    <SectionNumber>3.3.</SectionNumber>
                    <span>
                        Uživatel odesláním Objednávky v plném rozsahu přijímá a vyslovuje souhlas s těmito VOP  a
                        závazně objednává Vzdělávací akci dle její specifikace stanovené Poskytovatelem. Pokud bude
                        Vzdělávací akci využívat jiná osoba než Uživatel, zavazuje se Uživatel seznámit tuto osobu  s
                        těmito VOP. Za dodržování VOP touto osobou odpovídá Uživatel.
                    </span>
                </Description>
                <Description>
                    <SectionNumber>3.4.</SectionNumber>
                    <span>
                        Uživatel odesláním Objednávky zároveň v plném rozsahu potvrzuje úplnost a správnost veškerých
                        údajů uvedených v Objednávce. Uživatel se zavazuje Poskytovatele bez zbytečného odkladu písemně
                        informovat o jakékoliv změně těchto údajů. Poskytovatel si vyhrazuje právo ověřit v případě
                        pochybností úplnost a správnost Objednávky a údajů poskytnutých Uživatelem. Poskytovatel je
                        oprávněn neověřenou Objednávku odmítnout.
                    </span>
                </Description>
                <Description>
                    <SectionNumber>3.5.</SectionNumber>
                    <span>
                        Objednávky budou evidovány a zařazeny v pořadí, ve kterém došly. Přednostně jsou evidovány
                        uhrazené Objednávky, přičemž okamžikem přijetí platby se rozumí okamžik připsání platby ceny
                        Vzdělávací akce na účet Poskytovatele. V případě omezené kapacity Vzdělávací akce budou mít
                        přednost dřívější uhrazené Objednávky.
                    </span>
                </Description>
                <Description>
                    <SectionNumber>3.6.</SectionNumber>
                    <span>
                        V případě naplnění kapacity Vzdělávací akce Poskytovatel Uživatele informuje, že nedošlo  k
                        uzavření Smlouvy vzhledem ke konkrétní Vzdělávací akci. Poskytovatel je oprávněn Uživateli
                        nabídnout jako náhradu jinou Vzdělávací akci.
                    </span>
                </Description>
            </Container>
            <Container>
                <Label>4. OCHRANA OSOBNÍCH ÚDAJŮ</Label>
                <Description>
                    <SectionNumber>4.1.</SectionNumber>
                    <span>
                        Poskytovatel se jakožto správce osobních údajů, které mu budou Uživatelem na základě Smlouvy
                        poskytnuty, zavazuje, že bude tyto osobní údaje zpracovávat v souladu s právními předpisy,
                        především s Nařízením Evropského parlamentu a Rady (EU) 2016/679 ze dne 27. dubna 2016 o ochraně
                        fyzických osob v souvislosti se zpracováním osobních údajů a o volném pohybu těchto údajů a o
                        zrušení směrnice 95/46/ES a zákonem č. 480/2004 Sb., o některých službách informační společnosti
                        a o změně některých zákonů.
                    </span>
                </Description>
                <Description>
                    <SectionNumber>4.2.</SectionNumber>
                    <span>
                        Informace související se zpracováním osobních údajů Uživatele jsou obsahem dokumentu Ochrana
                        osobních údajů, který je dostupný na Webových portálech.
                    </span>
                </Description>
            </Container>
            <Container>
                <Label>5. CENA VZDĚLÁVACÍ AKCE</Label>
                <Description>
                    <SectionNumber>5.1.</SectionNumber>
                    <span>
                        Ceny jednotlivých Vzdělávacích akcích na Webových portálech jsou uvedeny včetně DPH  a zahrnují
                        účast na konkrétní Vzdělávací akci, studijní materiály v tištěné nebo elektronické podobě ke
                        konkrétní Vzdělávací akci uvedené v popisu Vzdělávací akce a v případě prezenční formy
                        Vzdělávací akce rovněž občerstvení uvedené v popisu Vzdělávací akce. V případě individuálních
                        cenových podmínek bude konečná cena po slevě uvedena v zálohové faktuře i v daňovém dokladu.
                        Uživatel se zavazuje nést veškeré související transakční náklady s cenou Vzdělávací akce, a to
                        zejména bankovní poplatky.
                    </span>
                </Description>
                <Description>
                    <SectionNumber>5.2.</SectionNumber>
                    <span>
                        Cena za dodání, zřízení nebo poskytnutí Vzdělávací akce poskytované Uživateli za úplatu je vždy
                        stanovena dle aktuálního ceníku Poskytovatele zveřejněného na Webových portálech.
                    </span>
                </Description>
                <Description>
                    <SectionNumber>5.3.</SectionNumber>
                    <span>
                        V případě zjevné chyby v ceně Vzdělávací akce na Webových portálech není Poskytovatel povinen
                        Vzdělávací akci za takovouto zjevně chybnou cenu poskytnout a vyhrazuje si právo odstoupit od
                        Smlouvy v případě, že Uživatel neuhradí bez zbytečného odkladu řádnou cenu Vzdělávací akce.
                    </span>
                </Description>
                <Description>
                    <SectionNumber>5.4.</SectionNumber>
                    <span>
                        Poskytovatel může Uživateli poskytnout slevu z ceny Služby. Poskytnutí slevy je výlučně na
                        uvážení Poskytovatele a Uživatel nemá na poskytnutí slevy nárok. Podrobnější informace  o
                        možnosti slev může Uživatel získat na telefonické lince Poskytovatele, na e-mailu Poskytovatele,
                        nebo na Webových portálech
                    </span>
                </Description>
                <Description>
                    <SectionNumber>5.5.</SectionNumber>
                    <span>
                        Poskytovatel je oprávněn ceník, strukturu a výši cen za poskytovanou Službu měnit, a to
                        v závislosti na aktuálních nákladech poskytnutí Služby.
                    </span>
                </Description>
            </Container>
            <Container>
                <Label>6. PLATEBNÍ PODMÍNKY</Label>
                <Description>
                    <SectionNumber>6.1.</SectionNumber>
                    <span>
                        Po obdržení Objednávky a/nebo po uzavření smlouvy o poskytnutí Vzdělávací akce vystaví
                        Poskytovatel Uživateli zálohovou fakturu na částku odpovídající ceně Vzdělávací akce dle
                        aktuálního ceníku se splatností 3 dnů.
                    </span>
                </Description>
                <Description>
                    <SectionNumber>6.2.</SectionNumber>
                    <span>Uživatel uhradí konkrétní Vzdělávací akci:</span>
                </Description>
                <ul>
                    <li>
                        Bezhotovostním převodem na bankovní účet Poskytovatele na základě zálohové faktury vystavené
                        Poskytovatelem ve lhůtě dle této zálohové faktury,
                    </li>
                    <li>On-line platební kartou prostřednictvím platební brány umístěné na Webových portálech.</li>
                </ul>
                <Description>
                    <SectionNumber>6.3.</SectionNumber>
                    <span>
                        Je-li Poskytovatelem vyžadováno zaplacení zálohy za Vzdělávací akci, je Poskytovatel oprávněn  v
                        případě nezaplacení ceny Vzdělávací akce podle zálohové faktury odepřít Uživateli využití
                        Vzdělávací akce. Splatnost zálohy na cenu Vzdělávací
                        akce činí v případě bezhotovostní platby tři pracovní dny ode dne odeslání Objednávky.
                    </span>
                </Description>
                <Description>
                    <SectionNumber>6.4.</SectionNumber>
                    <span>
                        Po zaplacení fakturované částky zašle Poskytovatel Uživateli konečnou fakturu elektronicky na
                        adresu uvedenou Uživatelem, s čímž Uživatel souhlasí přijetím těchto VOP. V případě zálohové
                        platby bude tato záloha započtena na cenu Vzdělávací akce a v plné výši vyúčtována. Daňové
                        doklady vystavené Poskytovatelem dle těchto VOP musí obsahovat veškeré náležitosti stanovené
                        platnými právními předpisy.
                    </span>
                </Description>
                <Label>Elektronická platba</Label>
                <Description>
                    <SectionNumber>6.5.</SectionNumber>
                    <span>
                        Uživatel má možnost provést platbu za jím vybranou Vzdělávací akci také prostřednictvím
                        platebních systémů Poskytovatele umístěných na Webových portálech.
                    </span>
                </Description>
                <Description>
                    <SectionNumber>6.6.</SectionNumber>
                    <span>
                        V případě takto provedené platby se za zaplacení Uživatelem objednané Vzdělávací akce považuje
                        připsání peněžních prostředků na účet Poskytovatele.
                    </span>
                </Description>
                <Description>
                    <SectionNumber>6.7.</SectionNumber>
                    <span>
                        Po připsání peněžních prostředků na účet Poskytovatele Poskytovatel vystaví a zašle Uživateli
                        konečnou fakturu v souladu se zákonem č. 235/2004 Sb., o dani z přidané hodnoty, ve znění
                        pozdějších předpisů.
                    </span>
                </Description>
                <Description>
                    <SectionNumber>6.8.</SectionNumber>
                    <span>
                        Uživatel se zavazuje uhradit cenu uvedenou v zálohové faktuře za poskytnutou Vzdělávací akci
                        řádně a včas, nejpozději v den splatnosti příslušné zálohové faktury. V opačném případě bude
                        Objednávka zrušena.
                    </span>
                </Description>
                <Description>
                    <SectionNumber>6.9.</SectionNumber>
                    <span>
                        Dojde-li na žádost nebo z důvodů na straně Uživatele ke změně sjednaného rozsahu poskytované
                        Vzdělávací akce, bude změněná cena, jakož i veškeré náklady, které musel Poskytovatel
                        v souvislosti s takovou změnou vynaložit, účtovány ode dne provedení změny Poskytovatelem.
                    </span>
                </Description>
            </Container>
            <Container>
                <Label>7. STORNO PODMÍNKY</Label>
                <Description>
                    <SectionNumber>7.1.</SectionNumber>
                    <span>
                        Jakékoliv změny nebo storno Objednávky lze učinit pouze písemnou formou e-mailem na adrese{' '}
                        <Link href="mailto: studiow@pp.cz">studiow@pp.cz</Link> nebo doporučeným dopisem na adresu
                        Poskytovatele.
                    </span>
                </Description>
                <Description>
                    <SectionNumber>7.2.</SectionNumber>
                    <span>Storno Objednávky lze učinit:</span>
                </Description>
                <ul>
                    <li>bezplatně nejpozději do 14 kalendářních dnů před konáním Vzdělávací akce,</li>
                    <li>
                        ve lhůtě 13 kalendářních dnů a kratší přede dnem konáním Vzdělávací akce činí storno poplatek
                        100 % ceny Vzdělávací akce.
                    </li>
                </ul>
                <Description>
                    <SectionNumber>7.3.</SectionNumber>
                    <span>
                        V případě storna Objednávky Uživatelem může Poskytovatel nabídnout Uživateli náhradní Vzdělávací
                        akci se stejným nebo obdobným tématem ve stejné nebo obdobné ceně nebo jakoukoliv jinou
                        Vzdělávací akci. V případě, že Poskytovatel nenabídne Uživateli jinou Vzdělávací akci nebo
                        Uživatel nebude mít o jinou Vzdělávací akci zájem, platí předchozí odstavec tohoto článku.
                    </span>
                </Description>
                <Description>
                    <SectionNumber>7.4.</SectionNumber>
                    <span>
                        Uživatel se v případě přijetí nabídky náhradní Vzdělávací akce zavazuje uhradit Poskytovateli
                        rozdíl v ceně Vzdělávací akce a náhradní Vzdělávací akce ve prospěch Poskytovatele. Poskytovatel
                        není povinen vracet Uživateli rozdíl v ceně Vzdělávací akce a náhradní Vzdělávací akce ve
                        prospěch Uživatele.
                    </span>
                </Description>
                <Description>
                    <SectionNumber>7.5.</SectionNumber>
                    <span>
                        V případě, že se Uživatel nemůže Vzdělávací akce zúčastnit, může Uživatel poslat náhradníka  s
                        tím, že jeho údaje sdělí Poskytovateli písemnou formou e-mailem nejpozději den před konáním
                        Vzdělávací akce. Uživatel je povinen uhradit cenu za Vzdělávací akci i v případě, že se Uživatel
                        Vzdělávací akce nezúčastní a jeho účast nebyla písemně zrušena v souladu s těmito VOP. Uhrazené
                        finanční prostředky za Vzdělávací akci se v tomto případě Uživateli Poskytovatelem nevrací a ani
                        Uživateli nevzniká nárok na jakoukoliv jinou kompenzaci nebo nárok na náhradní Vzdělávací akci.
                    </span>
                </Description>
                <Description>
                    <SectionNumber>7.6.</SectionNumber>
                    <span>
                        Uživatel, který je zároveň spotřebitelem, nemá v souladu s ustanovením § 1837 písm. j) zákona č.
                        89/2012 Sb., občanského zákoníku právo na odstoupení od Smlouvy bez udání důvodu.
                    </span>
                </Description>
            </Container>
            <Container>
                <Label>8. ORGANIZAČNÍ ZMĚNY</Label>
                <Description>
                    <SectionNumber>8.1.</SectionNumber>
                    <span>
                        Poskytovatel si vyhrazuje právo na změny programu Vzdělávací akce při dodržení její obsahové
                        náplně. Poskytovatel si dále vyhrazuje právo na změnu lektora, termínu, místa konání a doby
                        zahájení Vzdělávací akce a na zrušení Vzdělávací akce nebo její části z organizačních nebo
                        provozních důvodů, z důvodů nenaplnění kapacity Vzdělávací akce nebo v případě, že dojde  k
                        nečekávané a nepředvídatelné události (např. pandemie, stávka, přírodní katastrofa).
                    </span>
                </Description>
                <Description>
                    <SectionNumber>8.2.</SectionNumber>
                    <span>
                        Poskytovatel je oprávněn změnit formu Vzdělávací akce z prezenční na on-line a naopak.  V
                        případě změny formy Vzdělávací akce z prezenční na online není Uživatel oprávněn odstoupit od
                        Smlouvy a požadovat vrácení ceny Vzdělávací akce Poskytovatelem. Pokud Uživatel neakceptuje
                        novou formu Vzdělávací akce, je oprávněn vybrat si jinou Vzdělávací akci do jednoho roku od
                        termínu původní Vzdělávací akce. Poskytovatel je v případě změny právních předpisů pro případ
                        vyšší moci oprávněn řídit se těmito právními předpisy i v případě, že by tyto zvýhodňovaly
                        Poskytovatele nad rámec těchto VOP.
                    </span>
                </Description>
                <Description>
                    <SectionNumber>8.3.</SectionNumber>
                    <span>
                        Poskytovatel bude v případě jakékoliv změny Vzdělávací akce informovat Uživatele nejpozději
                        jeden pracovní den před konáním Vzdělávací akce na e-mailovou adresu uvedenou v Objednávce. V
                        případě, že nebude možné oznámit změnu lektora Vzdělávací akce v termínu dle tohoto odstavce, je
                        Poskytovatel oprávněn zajistit náhradního lektora. Vzdělávací akce se považuje v případě změny
                        lektora dle tohoto odstavce za uskutečněnou a Uživatel nemá nárok na odstoupení od Smlouvy ani
                        na vrácení ceny Vzdělávací akce.
                    </span>
                </Description>
                <Description>
                    <SectionNumber>8.4.</SectionNumber>
                    <span>
                        Pokud dojde ke změně termínu nebo zrušení Vzdělávací akce ze strany Poskytovatele, je Uživatel
                        oprávněn vybrat si Vzdělávací akci v jiném termínu nebo jinou Vzdělávací akci, pokud to umožňuje
                        kapacita Vzdělávací akce s výjimkami dle těchto VOP. Rozdíl v ceně Vzdělávací akce nese
                        v případě, že cena náhradní Vzdělávací akce bude vyšší, Uživatel, nedohodnou-li se Smluvní
                        strany jinak. V případě, že cena náhradní Vzdělávací akce bude nižší, nemá Uživatel nárok na
                        vrácení rozdílu v ceně, nedohodnou-li se Smluvní strany jinak, přičemž přeplatek může být
                        Uživatelem využit na nákup jiného produktu Poskytovatele. V případě, že Uživatel nevybere
                        náhradní Vzdělávací akci, má Uživatel nárok na odstoupení od Smlouvy a vrácení ceny Vzdělávací
                        akce s výjimkami dle těchto VOP
                    </span>
                </Description>
                <Description>
                    <SectionNumber>8.5.</SectionNumber>
                    <span>
                        Při zrušení Objednávky a odstoupení od Smlouvy kteroukoliv ze Smluvních stran ve lhůtě dle
                        těchto VOP bude Uživateli vrácena cena Vzdělávací akce snížená o případné storno poplatky nebo
                        její část stejným způsobem, jakým byla cena Vzdělávací akce uhrazena (v hotovosti, převodem na
                        účet), nedohodnou-li se Smluvní strany jinak, na základě opravného daňového dokladu (dobropisu)
                        ve lhůtě 30 dnů ode dne odstoupení od Smlouvy. Případné transakční poplatky spojené s vrácením
                        ceny Vzdělávací akce nese v plné výši Uživatel. Pokud bude Vzdělávací akce zrušena z důvodu na
                        straně Poskytovatele nese transakční poplatky za vrácení ceny Vzdělávací akce v obvyklé výši
                        společnost Poskytovatel. Již zaplacenou cenu Vzdělávací akce lze po dohodě Smluvních stran
                        použít jako zálohu na cenu za na jinou Vzdělávací akci.
                    </span>
                </Description>
            </Container>
            <Container>
                <Label>9. ORGANIZACE VZDĚLÁVACÍ AKCE</Label>
                <Description>
                    <SectionNumber>9.1.</SectionNumber>
                    <span>
                        Uživatel je oprávněn převést svoji účast na Vzdělávací akci na třetí osobu před termínem konání
                        Vzdělávací akce. Uživatel se zavazuje v takovém případě informovat Poskytovatele písemnou
                        formovou e-mailem nebo doporučeným dopisem nejpozději jeden pracovní den před konáním Vzdělávací
                        akce.
                    </span>
                </Description>
                <Description>
                    <SectionNumber>9.2.</SectionNumber>
                    <span>
                        Poskytovatel může v rámci Vzdělávací akce poskytnout Uživateli další plnění, například
                        vzdělávací materiály, záznam ze Vzdělávací akce, videoškolení, slevové vouchery na partnerské
                        produkty apod. (dále jen „Bonusy“). Podobu Bonusů vždy určuje Poskytovatel a Uživatel není
                        oprávněn požadovat náhradní plnění. Uživatel si vyhrazuje právo poskytnutí Bonusů kdykoliv
                        zrušit. Není-li uvedeno jinak, Bonusy nejsou poskytovány k partnerským Vzdělávacím akcím. Pokud
                        se Uživatel nedostaví na Vzdělávací akci a Vzdělávací akce byla Uživatelem řádně uhrazena,
                        náleží Uživateli vzdělávací materiály a Bonusy Vzdělávací akce, pokud je možné tyto materiály
                        poskytnout v elektronické podobě.
                    </span>
                </Description>
                <Description>
                    <SectionNumber>9.3.</SectionNumber>
                    <span>
                        Uživatel bere na vědomí a souhlasí, že není oprávněn bez výslovného souhlasu Poskytovatele  v
                        průběhu Vzdělávací akce pořizovat žádné zvukové či zvukově obrazové záznamy Vzdělávací akce.
                        Jakékoliv pořízené zvukové či zvukově obrazové záznamy Vzdělávací akce není Uživatel oprávněn
                        jakýmkoliv způsobem dále šířit, zpřístupňovat nebo jinak poskytovat třetím osobám.
                    </span>
                </Description>
                <Description>
                    <SectionNumber>9.4.</SectionNumber>
                    <span>
                        Uživatel bere na vědomí a souhlasí že Vzdělávací akce jsou určeny pro odborníky v dané oblasti a
                        předpokládají odbornou znalost účastníků Vzdělávacích akcí v těchto oborech. Poskytovatel
                        neodpovídá za neporozumění nebo nepochopení obsahu Vzdělávací akce Uživatelem způsobené
                        nedostatečnou odborností Uživatele v dané oblasti. Uživatel dále bere na vědomí a souhlasí, že
                        odborné názory lektora konkrétní Vzdělávací akce nemusí být shodné s názory jiných odborníků v
                        daném oboru.
                    </span>
                </Description>
                <Description>
                    <SectionNumber>9.5.</SectionNumber>
                    <span>
                        Uživatel bere na vědomí a souhlasí, že obsah webových stránek, vzdělávací materiály a další
                        informace poskytnuté Poskytovatelem mohou být chráněny autorským právem Poskytovatele nebo třetí
                        osoby. Uživatel není bez souhlasu Poskytovatele oprávněn tyto informace dále šířit, zveřejňovat
                        nebo zpřístupňovat třetím osobám. Uživatel bere na vědomí, že Poskytovatel je oprávněna domáhat
                        se v případě porušení autorského práva Poskytovatele, nebo třetích osob upuštění od dalších
                        zásahů do autorského práva a náhrady škody a nemajetkové újmy.
                    </span>
                </Description>
                <Description>
                    <SectionNumber>9.6.</SectionNumber>
                    <span>
                        V případě registrace Uživatele na Webových portálech nenese Poskytovatel jakoukoliv odpovědnost
                        za ztrátu nebo zpřístupnění přihlašovacích údajů třetí osobě Uživatelem. Uživatel se zavazuje
                        uvést při registraci na Webových portálech pravdivé a úplné údaje, jinak je Poskytovatel
                        oprávněn uživatelský účet Uživatele zrušit. Poskytovatel je oprávněn přístup Uživatele zrušit
                        rovněž v případě nezákonného jednání nebo porušení těchto VOP Uživatelem prostřednictvím
                        webového rozhraní.
                    </span>
                </Description>
                <Description>
                    <SectionNumber>9.7.</SectionNumber>
                    <span>
                        Poskytovatel si vyhrazuje právo pořizovat zvukové a zvukově obrazové záznamy Vzdělávací akce, na
                        nichž může být rovněž zachycena podoba Uživatele nebo jiných účastníků Vzdělávací akce.
                        Poskytovatel je oprávněn tyto záznamy užít pro marketingové a jiné obchodní účely. Uživatel
                        účastní na Vzdělávací akci vyslovuje svolení s rozšiřováním své podoby za účelem dle tohoto
                        odstavce. Svolení je uděleno na dobu neurčitou a může být kdykoliv odvoláno.
                    </span>
                </Description>
            </Container>
            <Container>
                <Label>10. PRÁVA Z VADNÉHO PLNĚNÍ</Label>
                <Description>
                    <SectionNumber>10.1.</SectionNumber>
                    <span>
                        Poskytovatel odpovídá za bezvadné poskytnutí Vzdělávací akce, zejména že Vzdělávací akce bude
                        poskytnuta v termínu, v místě a s obsahem dle Objednávky a bude odpovídat popisu Vzdělávací akce
                        uvedené na Webových portálech.
                    </span>
                </Description>
                <Description>
                    <SectionNumber>10.2.</SectionNumber>
                    <span>
                        Uživatel má v případě vadného plnění společností Poskytovatele právo na odstranění vady
                        Vzdělávací akce. V případě, že není odstranění vady Vzdělávací akce možné, má Uživatel právo na
                        přiměřenou slevu z ceny Vzdělávací akce. V případě podstatného porušení Smlouvy má Uživatel
                        právo na odstoupení od Smlouvy.
                    </span>
                </Description>
                <Description>
                    <SectionNumber>10.3.</SectionNumber>
                    <span>
                        Uživatel bere na vědomí a souhlasí, že práva z vadného plnění Uživateli nenáleží, pokud o vadě
                        Vzdělávací akce věděl před uzavřením Smlouvy nebo pokud tuto vadu sám způsobil.
                    </span>
                </Description>
                <Description>
                    <SectionNumber>10.4.</SectionNumber>
                    <span>
                        Uživatel je povinen vady Vzdělávací akce reklamovat bez zbytečného odkladu po jejich zjištění
                        písemnou formou na e-mail nebo doporučeným dopisem Poskytovateli. Uživatel je povinen  v
                        reklamaci konkrétně uvést, v čem spatřuje vadu Vzdělávací akce, a požadované právo  z
                        odpovědnosti za vady.
                    </span>
                </Description>
                <Description>
                    <SectionNumber>10.5.</SectionNumber>
                    <span>
                        Poskytovatel se zavazuje reklamaci vyřídit od jejího řádného a včasného uplatnění bez zbytečného
                        odkladu, nejpozději však do 30 dnů ode dne doručení reklamace.
                    </span>
                </Description>
            </Container>
            <Container>
                <Label>11. OZNAMOVÁNÍ</Label>
                <Description>
                    <SectionNumber>11.1.</SectionNumber>
                    <span>
                        Oznámení nebo jiné sdělení podle těchto VOP musí být učiněna písemně v českém jazyce,  a podle
                        povahy věci může být zasláno e-mailem na <Link href="mailto: studiow@pp.cz">studiow@pp.cz</Link>
                        , poštou Praha 7, Jablonského 639/4, PSČ 17000) nebo sděleno telefonicky +420 606 610 126 a
                        prostřednictvím webových stránek{' '}
                        <Link href="https://www.studiow.cz">https://www.studiow.cz</Link>
                    </span>
                </Description>
                <Description>
                    <SectionNumber>11.2.</SectionNumber>
                    <span>
                        Změnu kontaktních údajů se Smluvní strany zavazují oznámit druhé Smluvní straně bez zbytečného
                        odkladu od této změny, přičemž změna je účinná ve lhůtě 5 dnů ode dne doručení oznámení druhé
                        Smluvní straně.
                    </span>
                </Description>
                <Description>
                    <SectionNumber>11.3.</SectionNumber>
                    <span>
                        Jakékoliv úkony směřující k ukončení Smlouvy musí být oznámeny druhé Smluvní straně písemně
                        formou e-mailu nebo doporučeného dopisu.
                    </span>
                </Description>
            </Container>
            <Container>
                <Label>12. ZÁVĚREČNÁ USTANOVENÍ</Label>
                <Description>
                    <SectionNumber>12.1.</SectionNumber>
                    <span>
                        Právní vztahy mezi Poskytovatelem a Uživatelem neupravené VOP se řídí právním řádem České
                        republiky, zejména zákonem č. 89/2012 Sb., občanský zákoník.
                    </span>
                </Description>
                <Description>
                    <SectionNumber>12.2.</SectionNumber>
                    <span>Tyto VOP nabývají platnosti a účinnosti 3.2.2025.</span>
                </Description>
                <Description>
                    <SectionNumber>12.3.</SectionNumber>
                    <span>
                        Aktuální VOP jsou zveřejněny po dobu dvaceti čtyř (24) hodin denně na Webových portálech  a v
                        tištěné podobě jsou k dispozici na adrese sídla Poskytovatele.
                    </span>
                </Description>
                <Description>
                    <SectionNumber>12.4.</SectionNumber>
                    <span>
                        Případné spory budou řešeny u příslušného soudu České republiky. Současně budou případné
                        stížnosti Uživatelů v postavení spotřebitelů řešeny v souladu se zákonem č. 634/1992 Sb.,  o
                        ochraně spotřebitele, ve znění pozdějších předpisů. Stížnosti je třeba podat písemně na adresu
                        Poskytovatele.
                    </span>
                </Description>
                <Label>Mimosoudní řešení spotřebitelských sporů</Label>
                <Description>
                    <SectionNumber>12.5.</SectionNumber>
                    <span>
                        Mimosoudní řešení spotřebitelských sporů je postup, jehož cílem je dosáhnout smírného řešení
                        sporu mezi jeho stranami. Uživatel může řešit svůj spor s Poskytovatelem prostřednictvím
                        mimosoudního řešení spotřebitelských sporů.
                    </span>
                </Description>
                <Description>
                    <SectionNumber>12.6.</SectionNumber>
                    <span>
                        V případě, že je Uživatel spotřebitelem, je k mimosoudnímu řešení případných spotřebitelských
                        sporů vzniklých ze Smlouvy příslušná Česká obchodní inspekce (www.coi.cz). Návrh na zahájení
                        řešení sporu může Uživatel-spotřebitel podat nejpozději do 1 roku od chvíle, kdy poprvé uplatnil
                        svůj nárok u Poskytovatele.
                    </span>
                </Description>
                <Description>
                    <Bold>Česká obchodní inspekce</Bold>
                </Description>
                <Description>
                    <Bold>Ústřední inspektorát – oddělení ADR</Bold>
                </Description>
                <Description>Štěpánská 15</Description>
                <Description>120 00 Praha 2</Description>
                <Description>Email: adr@coi.cz</Description>
                <Description>Webové stránky: adr.coi.cz</Description>
                <Description>
                    U stejného orgánu je Uživatel – spotřebitel oprávněn podat stížnost na Poskytovatele
                </Description>
                <Description>
                    <SectionNumber>12.7.</SectionNumber>
                    <span>
                        Mimosoudní vyřizování stížností Uživatelů – spotřebitelů zajišťuje Poskytovatel na e-mailové
                        adrese: <Link href="mailto: studiow@pp.cz">studiow@pp.cz</Link> – informaci o vyřízení stížnosti
                        zašle Poskytovatel Uživateli – spotřebiteli na jeho e-mail, z něhož stížnost obdržel.
                    </span>
                </Description>
                <Description>
                    <SectionNumber>12.8.</SectionNumber>
                    <span>
                        Spotřebitel může využít rovněž platformu pro řešení sporů on-line, která je zřízena Evropskou
                        komisí na adrese http://ec.europa.eu/consumers/odr/.
                    </span>
                </Description>
                <Description>
                    <SectionNumber>12.9.</SectionNumber>
                    <span>
                        Uživatel může podat návrh na zahájení mimosoudního řešení sporu prostřednictvím platformy pro
                        mimosoudní řešení sporů – viz čl. 14 odst. 1 a 2 nařízení Evropského parlamentu a Rady (EU)  č.
                        524/2013 ze dne 21. května 2013 o řešení spotřebitelských sporů on-line a o změně nařízení (ES)
                        č. 2006/2004 a směrnice 2009/22/ES (nařízení o řešení spotřebitelských sporů on-line) (Úř. věst.
                        L 165, 18.6.2013).
                    </span>
                </Description>
                <Description>
                    Odkaz na platformu:{' '}
                    <Link href="https://ec.europa.eu/consumers/odr/main/index.cfm?event=main.home2.show&lng=CS">
                        https://ec.europa.eu/consumers/odr/main/index.cfm?event=main.home2.show&lng=CS
                    </Link>
                </Description>
                <Description>
                    <strong>Přílohy</strong>:
                </Description>
                <Description>
                    <Link target="_blank" href="https://wcm.prod.studiow.cz/media/static/vzdelavaci-akce.pdf">
                        Příloha 1: Vzdělávací akce
                    </Link>
                </Description>
                <Description>
                    <Link target="_blank" href="https://studiow.cz/ochrana-osobnich-udaju">
                        Příloha 2: Ochrana osobních údajů
                    </Link>
                </Description>
            </Container>
        </Wrapper>
    );
};

export default BusinessConditionsTemplate;
